import { render } from "./CreateEmbeded.vue?vue&type=template&id=31212f3c&scoped=true"
import script from "./CreateEmbeded.vue?vue&type=script&lang=js"
export * from "./CreateEmbeded.vue?vue&type=script&lang=js"

import "./CreateEmbeded.vue?vue&type=style&index=0&id=31212f3c&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31212f3c"]])

export default __exports__